const closeOverlay = (
  title: string,
  copy: string,
  setSubmitResonse: Function,
  disabled?: boolean,
) => {
  if (window && window.location !== window.parent.location && !disabled) {
    const message = {
      id: 'gb-iframe-close',
      data: {
        title,
        copy: copy || '',
      },
    }

    window.parent.postMessage(message, '*')
    // eslint-disable-next-line no-console
    console.log('[GB] Close overlay message sent:', message)
  } else {
    setSubmitResonse(`${title} ${copy || ''}`)
  }
}

export default closeOverlay
